import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Card, Container } from "react-bootstrap";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { SubmitBar, Loader } from "@egovernments/digit-ui-react-components";
import ReactToPrint from "react-to-print";
import FormatSlip from "./FormatSlip";
import { ToWords } from "to-words";
import { useTranslation } from "react-i18next";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";

const PaymentPrint = (props) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const conponentPDF = useRef();
  const toWords = new ToWords();
  const [loader, setLoader] = useState(false);
  const [scrutinyTable, setScrutinyTable] = useState(null);
  const [logoData, setLogoData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [amountDetails, setAmountDetails] = useState(null);
  const userInfo = Digit.UserService.getUser()?.info || {};
  const authToken = Digit.UserService.getUser()?.access_token || null;
  const getApplicationPay = async () => {
    setLoader(true);
    // const token = window?.localStorage?.getItem("token");

    let requestInfo = {
      RequestInfo: {
        apiId: "Rainmaker",
        ver: "v1",
        ts: 0,
        action: "_search",
        did: "",
        key: "",
        msgId: "090909",
        requesterId: "",
        authToken: authToken,
        userInfo: userInfo,
      },
    };
    try {
      const Resp = await axios.post(`/pg-service/transaction/v1/_search?consumerCode=${id}`, requestInfo).then((response) => {
        return response?.data;
      });
      setLoader(false);
      console.log("Responsdhgdhdeygfg", Resp);
      setScrutinyTable(Resp?.Transaction?.[0]);
      const amountPaid = Resp?.Transaction?.[0]?.additionalDetails?.taxAndPayments[0]?.amountPaid;
      if (amountPaid) {
        const wordsList = toWords.convert(amountPaid, { currency: true, ignoreDecimal: false });
        setAmountDetails(wordsList);
        console.log("5555555555", wordsList);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getApplicationPay("");
  }, [id]);

  const { isLoading, data: applicationDetails } = Digit.Hooks.obps.useLicenseDetails(stateId, { applicationNumber: id }, {});
  const { eg_pg_txnid: egId, txnStatus: txn, workflow: workflw } = Digit.Hooks.useQueryParams();
  const { isLoading: paymentLoading, data, isError } = Digit.Hooks.usePaymentUpdate(
    { egId, txn },
    {
      retry: false,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    const fetchData = async () => {
      const department = applicationDetails?.applicationData?.department;
      const locationDistrict = applicationDetails?.applicationData?.location1;

      if (!department) return;

      setLoading(true); // Notify parent loading started

      const authToken = Digit.UserService.getUser()?.access_token;

      const requestInfo = {
        RequestInfo: {
          apiId: "Rainmaker",
          msgId: "1669293303096|en_IN",
          authToken: authToken,
        },
      };

      let url = `${Urls.logoUrl.bpaLogoUrl}department=${department}`;
      if (department !== "AVP" && locationDistrict) {
        url += `&district=${locationDistrict}`;
      }

      try {
        const response = await axios.post(url, requestInfo);
        setLogoData(response?.data);
        console.log("Logo API response:", response?.data);
      } catch (error) {
        console.error("Logo API call failed:", error);
        setLogoData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [applicationDetails?.applicationData?.department, applicationDetails?.applicationData?.location1]);

  if (loading || loader) {
    return <Loader />;
  }
  console.log({ scrutinyTable, amountDetails, applicationDetails, logoData }, "in ltp details slip");
  return (
    <Container
      className="justify-content-center"
      style={{
        minWidth: "100%",
        maxWidth: "100%",
        maxHeight: "50%",
        minHeight: "40%",
        marginTop: 5,
      }}
    >
      <Card>
        <div ref={conponentPDF}>
          <div>
            <FormatSlip
              scrutinyTable={scrutinyTable}
              scrutinyDetails={applicationDetails?.applicationData?.tradeLicenseDetail?.owners?.[0]}
              scrutinyData={applicationDetails?.applicationData}
              wordslist={amountDetails}
              id={id}
              logoData={logoData}
            />
          </div>
        </div>
        <Row className="justify-content-space-between" style={{ padding: "10px", marginTop: 20 }}>
          <Col xs="4">
            <Link to={`/digit-ui/citizen/profile`}>
              <SubmitBar style={{ marginLeft: "85px" }} label={t("CORE_COMMON_GO_TO_HOME")} />
            </Link>
          </Col>
          <Col xs="4"></Col>
          <Col xs="4">
            <ReactToPrint
              trigger={() => (
                <button class="btn btn-success" id="invoice-print">
                  Print Payment Receipt
                </button>
              )}
              content={() => conponentPDF.current}
            />
          </Col>
        </Row>
      </Card>
    </Container>
  );
};

export default PaymentPrint;
